/* unplugin-vue-components disabled */import { render } from "./comp5app.vue?vue&type=template&id=52bad6af&scoped=true"
import script from "./comp5app.vue?vue&type=script&lang=js"
export * from "./comp5app.vue?vue&type=script&lang=js"

import "./comp5app.vue?vue&type=style&index=0&id=52bad6af&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bad6af"]])

export default __exports__